var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.visible,
            size: "large",
            title: _vm.$t.__("email.EmailCustomTemplateModal.title_dialog")
          },
          on: { "update:visible": _vm.handleCloseModal }
        },
        [
          _c("template", { slot: "default" }, [
            _vm.isNoTemplateOnList && !_vm.isLoadingGetTemplates
              ? _c(
                  "div",
                  {
                    staticClass:
                      "email-custom-template-modal__no-template-on-list"
                  },
                  [
                    _c(
                      "CompassEmptyState",
                      {
                        attrs: {
                          illustrationPath:
                            "/ressources/logged/img/illustrations/custom-email-template-no-result.svg",
                          title: _vm.$t.__(
                            "email.EmailCustomTemplateModal.title_no_template"
                          ),
                          caption: _vm.$t.__(
                            "email.EmailCustomTemplateModal.caption_no_template"
                          )
                        }
                      },
                      [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__(
                              "email.EmailCustomTemplateModal.btn_label_no_template"
                            ),
                            "data-bot":
                              "email-custom-template-modal__no-template-button"
                          },
                          on: { click: _vm.handleNewTemplate }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "email-custom-template-modal__container" },
                  [
                    _c(
                      "div",
                      { staticClass: "email-custom-template-modal__list" },
                      [
                        _c(
                          "CompassInput",
                          {
                            staticClass: "email-custom-template-modal__search",
                            attrs: {
                              type: "search",
                              placeholder: _vm.$t.__("common.actions.search"),
                              prefixIcon: "search",
                              disabled: _vm.isDisabledInput,
                              "data-bot": "email-custom-template-modal__search"
                            },
                            model: {
                              value: _vm.searchQuery,
                              callback: function($$v) {
                                _vm.searchQuery = $$v
                              },
                              expression: "searchQuery"
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "suffix" },
                              [
                                _c("CompassIconButton", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasSearchQuery,
                                      expression: "hasSearchQuery"
                                    }
                                  ],
                                  attrs: {
                                    icon: "close",
                                    size: "small",
                                    disabled: _vm.isDisabledInput,
                                    "data-bot":
                                      "email-custom-template-modal__reset"
                                  },
                                  on: { click: _vm.resetInput }
                                })
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-custom-template-modal__list-container"
                          },
                          [
                            _vm.isNoFilterResult
                              ? _c("CompassEmptyState", {
                                  attrs: {
                                    illustrationPath:
                                      "/ressources/logged/img/illustrations/no-results.svg",
                                    title: _vm.$t.__(
                                      "email.EmailCustomTemplateModal.title_no_result"
                                    ),
                                    caption: _vm.$t.__(
                                      "email.EmailCustomTemplateModal.caption_no_result"
                                    )
                                  }
                                })
                              : _vm.isLoadingGetTemplates
                              ? _vm._l(
                                  _vm.skeletonListTemplateClasses,
                                  function(skeletonClass, index) {
                                    return _c("CompassSkeleton", {
                                      key: index,
                                      class: [
                                        "email-custom-template-modal__skeleton",
                                        skeletonClass
                                      ],
                                      attrs: { size: "large" }
                                    })
                                  }
                                )
                              : _vm._l(_vm.filteredItems, function(item) {
                                  return _c(
                                    "li",
                                    {
                                      key: item.id,
                                      class: _vm.listItemClasses(item),
                                      attrs: {
                                        "data-bot":
                                          "email-custom-template-modal__item"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "selectTemplate",
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.name) +
                                          "\n                            "
                                      ),
                                      item.hasAi
                                        ? _c("CompassIcon", {
                                            staticClass:
                                              "email-custom-template-modal__ai-icon",
                                            attrs: {
                                              icon: "ai-sparkles-simple",
                                              size: "small"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-custom-template-modal__btn-new-template",
                            attrs: {
                              "data-bot":
                                "email-custom-template-modal__btn-new-template"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleNewTemplate()
                              }
                            }
                          },
                          [
                            _c("CompassIcon", {
                              attrs: { icon: "plus", type: "link" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-semibold"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t.__(
                                        "email.EmailCustomTemplateModal.create_new_template"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "email-custom-template-modal__details" },
                      [
                        _vm.isLoadingSelectTemplate
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "email-custom-template-modal__details--skeleton-container"
                              },
                              [
                                _c("CompassSkeleton", {
                                  class: _vm.skeletonTemplateTitleClasses,
                                  attrs: { size: "large" }
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.skeletonTemplateClasses, function(
                                  skeletonClass,
                                  index
                                ) {
                                  return _c("CompassSkeleton", {
                                    key: index,
                                    class: [
                                      "email-custom-template-modal__skeleton",
                                      skeletonClass
                                    ]
                                  })
                                })
                              ],
                              2
                            )
                          : _vm.selectedTemplate
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "email-custom-template-modal__details-content rich-text-style"
                              },
                              [
                                _c("h3", {
                                  staticClass: "typographies-heading-h3",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formattedContent(
                                        _vm.selectedTemplate.subject
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "typographies-paragraph-medium-regular email-custom-template-modal__details-content__text",
                                  class: _vm.editorClass,
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formattedContent(
                                        _vm.selectedTemplate.message
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _vm.selectedTemplate.attachments.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "email-custom-template-modal__attachments"
                                      },
                                      _vm._l(
                                        _vm.selectedTemplate.attachments,
                                        function(attachment) {
                                          return _c("EmailAttachmentLink", {
                                            key: attachment.id,
                                            attrs: {
                                              file: attachment,
                                              size: "small"
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          !_vm.isNoTemplateOnList
            ? _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "email-custom-template-modal__footer" },
                  [
                    _vm.showRemainingQuota
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "email-custom-template-modal__remaining-quota"
                          },
                          [
                            _vm.quotaAILimitReached
                              ? _c("CompassFeatureBadge", {
                                  attrs: {
                                    variant: "upsell",
                                    size: "extra-small"
                                  }
                                })
                              : _c("img", {
                                  staticClass: "ai-icon",
                                  attrs: {
                                    src:
                                      "/ressources/logged/img/icon/svg/ai-icon-write.svg",
                                    alt: "ai icon"
                                  }
                                }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "typographies-paragraph-x-small-regular"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.remainingQuotaLabel) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary",
                        disabled: _vm.isLoadingAddTemplateOnContentEmail
                      },
                      on: { click: _vm.handleCloseModal }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.getLabelPrimaryAction,
                        loading: _vm.isLoadingAddTemplateOnContentEmail
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit(
                            "addTemplateOnContentEmail",
                            _vm.selectedTemplate.id
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }